import { Box } from '@mui/material'
import DGSegregationRulesTable from '@yard/features/dg-segregation-rules/components/DGSegregationRulesTable'
import DGSegregationRulesTableDialog from '@yard/features/dg-segregation-rules/components/DGSegregationRulesTableDialog'

export const DGSegregationRulesPage = () => (
  <Box>
    <DGSegregationRulesTable />
    <DGSegregationRulesTableDialog />
  </Box>
)

export default DGSegregationRulesPage
